module.exports = __webpack_public_path__ + "img/Map.1a741126.png";